module.exports = __webpack_public_path__ + "static/media/dream.33fc8b85.jpg";